module.exports = __webpack_public_path__ + "static/img/loginlogo.c3966881.png";